// #region imports

// --- Angular
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  OnChanges,
  SimpleChanges
} from '@angular/core';

// --- RxJs
import { Subject, Subscription, BehaviorSubject } from 'rxjs';

// --- 3rd Party
import moment from 'moment';

// --- HS Code
import { ResultsStatuses, SurveyStatuses, SurveySummaryModel } from '../../../models';
import { GoogleAnalyticsService } from 'src/app/core/services/google-analytics.service';

// #endregion

@Component({
  selector: 'hs-survey-widget-v2',
  templateUrl: './survey-widget-v2.component.html',
  styleUrls: ['./survey-widget-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SurveyWidgetV2Component implements OnInit, OnChanges {
  @Input() surveys: Array<SurveySummaryModel> = new Array<SurveySummaryModel>();
  @Input() selectedSurvey: SurveySummaryModel | null = null;
  @Input() reportIsLoading: boolean = false;
  @Input() reportIsDownLoading: boolean = false;

  @Output() startContinueButtonClicked = new EventEmitter<SurveySummaryModel>();
  @Output() downloadReportClicked = new EventEmitter<string>();

  dateOfClose: string | undefined;
  dateOfReportRelease: string | undefined;

  othersProgress: number | undefined;
  showError: boolean | undefined;

  currentDate: Date = new Date();

  resultsStatuses = ResultsStatuses;
  surveyStatuses = SurveyStatuses;

  constructor(
    private googleAnalyticsService: GoogleAnalyticsService
  ) {}

  ngOnInit() {
    this.currentDate = moment().subtract(moment().utcOffset(), 'm').toDate();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['selectedSurvey'] && changes['selectedSurvey'].currentValue) {
      this.dateOfClose =
        moment(changes['selectedSurvey'].currentValue.dateOfClose)
          .format('D MMMM YYYY');
      this.dateOfReportRelease =
        moment(changes['selectedSurvey'].currentValue.dateOfReportRelease)
          .format('D MMMM YYYY');
    }
  }

  onWidgetButtonClick(buttonName: string): void {
    switch (buttonName) {
      case 'start':
        this._startButtonClicked();
        break;
      case 'downloadReport':
        if (this.selectedSurvey) {
          this.googleAnalyticsService.eventEmitter("view_participant_report", "report", "download")
          this.downloadReportClicked.emit(this.selectedSurvey.id);
        }
        break;
      default:
        console.warn('unexpected button name: ' + buttonName);
    }
  }

  isBeforeReportReleaseDate(): boolean {
    const now = new Date();
    const d = new Date(Date.UTC(now.getFullYear(), now.getMonth() + 1, now.getDay(), now.getHours(), now.getMinutes()));

    return moment(d).isBefore(moment(this.dateOfReportRelease));
  }

  private _startButtonClicked(): void {
    if (this.selectedSurvey) {
      this.googleAnalyticsService.eventEmitter("participant_survey", "survey", "start")
      this.startContinueButtonClicked.emit(this.selectedSurvey);
    }
  }
}
